import React from 'react';
import PropTypes from 'prop-types';
import PaymentLogDTO from '../../DTOs/Subscription/PaymentLogDTO';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { trimDate } from '../../utilities/DateFormat';

export default function TransactionCardMobile(props) {
    const { transaction } = props;

    return (
        <MobileCard
            title={USDollar.format(transaction.amount)}
            subtitle={`Unit ${transaction.storageUnit.name}`}
            status={{ label: transaction.paymentProcessorStatus }}
            fields={[
                { label: 'Date', value: trimDate(transaction.transactionDate) },
                {
                    label: 'Tenant',
                    value: `${transaction.appUser.firstName} ${transaction.appUser.lastName}`,
                },
                { label: 'Email', value: transaction.appUser.username },
                { label: 'Transaction', value: transaction.transactionid },
            ]}
        />
    );
}

TransactionCardMobile.propTypes = {
    transaction: PropTypes.objectOf(PaymentLogDTO),
};
